import { async_chatgpt } from "../ai-results-examples/async_chatgpt";
import { async_google_gemini } from "../ai-results-examples/async_google_gemini";
import { async_google_ai_mode } from "../ai-results-examples/async_google_ai_mode";
import { async_perplexity } from "../ai-results-examples/async_perplexity";
import { async_amazon_offer } from "./async_amazon_offer";
import { async_amazon_product } from "./async_amazon_product";
import { async_amazon_review } from "./async_amazon_review";
import { async_amazon_search } from "./async_amazon_search";
import { async_ebay_product } from "./async_ebay_product";
import { async_ebay_search } from "./async_ebay_search";
import { async_homedepot_search } from "./async_homedepot_search";
import { async_homedepot_product } from "./async_homedepot_product";
import { async_homedepot_reviews } from "./async_homedepot_reviews";
import { async_google_jobs } from "./async_google_jobs";
import { async_google_maps_search } from "./async_google_maps_search";
import { async_google_news } from "./async_google_news";
import { async_google_search } from "./async_google_search";
import { async_google_shopping } from "./async_google_shopping";
import { async_redfin_forsale } from "./async_redfin_forsale";
import { async_redfin_search } from "./async_redfin_search";
import { async_walmart_category } from "./async_walmart_category";
import { async_walmart_product } from "./async_walmart_product";
import { async_walmart_review } from "./async_walmart_review";
import { async_walmart_search } from "./async_walmart_search";


const examples: { [ index: string ]: { input: string, result: string } } = {
  async_chatgpt,
  async_amazon_offer,
  async_amazon_product,
  async_amazon_review,
  async_amazon_search,
  async_ebay_product,
  async_ebay_search,
  async_homedepot_search,
  async_homedepot_product,
  async_homedepot_reviews,
  async_google_ai_mode,
  async_google_gemini,
  async_google_jobs,
  async_google_maps_search,
  async_google_news,
  async_google_search,
  async_google_shopping,
  async_perplexity,
  async_redfin_forsale,
  async_redfin_search,
  async_walmart_category,
  async_walmart_product,
  async_walmart_review,
  async_walmart_search,
};

export default examples;
